import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import InputMask from 'react-input-mask';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';
import SignaturePad from 'react-signature-pad'

class FlightReportRefuelMultipleFieldsTab extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      refuel_index: this.props.refuel_index,
      id: this.props.data.id,
      date: this.props.data.date,
      comments: this.props.data.comments,
      fields_type: this.props.fields_type,
      maintenance_association: this.props.data.maintenance_association,
      extra_flight: this.props.data.extra_flight,
      internal_storage_tank: this.props.data.internal_storage_tank,
      receit: this.props.data.receit,
      auto_receit: this.props.data.auto_receit,
      quantity: this.props.data.quantity,
      truck_no: this.props.data.truck_no,
      fueling_started: this.props.data.fueling_started,
      fueling_finished: this.props.data.fueling_finished,
      reading_start: this.props.data.reading_start,
      reading_finish: this.props.data.reading_finish,
      fuel_type_id: this.props.data.fuel_type_id,
      fuel_types_select: this.props.fuel_types_select,
      last_type: this.props.last_type,
      request_data: this.props.request_data,
      user: this.props.user,
      is_form_valid: false,
      modal_approval: false,
      name: '',
      customer_id: this.props.data.customer_id,
      customer_name: this.props.data.customer_name,
      customer_status: this.props.data.customer_status,
      supervisor_id: this.props.data.supervisor_id,
      supervisor_name: this.props.data.supervisor_name,
      supervisor_status: this.props.data.supervisor_status,
    };
    //Handlers
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.saveRefuel = this.saveRefuel.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.clearSignature = this.clearSignature.bind(this);
    this.approval_signature = this.approval_signature.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    this.props.handleChangeRefuelData(name, event.target.value, this.state.refuel_index);
  }

  handleChangeName (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    this.props.handleChangeRefuelData(name, event.target.value, this.state.refuel_index);
  }

  handleChangeGallonsReading (name, event) {
    if (name == 'reading_start') {
      var start = event.target.value;
    } else {
      var start = this.state.reading_start;
    }
    if (name == 'reading_finish') {
      var finish = event.target.value;
    } else {
      var finish = this.state.reading_finish;
    }
    var delivered = (parseInt(finish) - parseInt(start));
    //Se o delivered não for um número inteiro positivo, então seto como 0
    if (isNaN(delivered) || delivered < 0) {
      delivered = 0;
    }
    this.props.handleChangeRefuelData(name, event.target.value, this.state.refuel_index);
    this.props.handleChangeRefuelData('quantity', delivered, this.state.refuel_index);
  }


  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2});
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    //Verifico se o id é nulo, se for, é um novo registro
    //O campo data vem no formato yyyy-mm-dd se for um registro capturado do banco, então capturo o date_str
    //Se for um registro novo, o date_str é nulo, então capturo o date
    var date = newProps.data.date_str;
    if (typeof newProps.data.id === 'undefined' || newProps.data.id === null) {
      date = newProps.data.date;
    }
    this.setState({
      refuel_index: newProps.refuel_index,
      id: newProps.data.id,
      date: date,
      comments: newProps.data.comments,
      fields_type: newProps.fields_type,
      maintenance_association: newProps.data.maintenance_association,
      extra_flight: newProps.data.extra_flight,
      internal_storage_tank: newProps.data.internal_storage_tank,
      receit: newProps.data.receit,
      quantity: newProps.data.quantity,
      truck_no: newProps.data.truck_no,
      fueling_started: newProps.data.fueling_started,
      fueling_finished: newProps.data.fueling_finished,
      reading_start: newProps.data.reading_start,
      customer_id: newProps.data.customer_id,
      customer_name: newProps.data.customer_name,
      customer_status: newProps.data.customer_status,
      supervisor_id: newProps.data.supervisor_id,
      supervisor_name: newProps.data.supervisor_name,
      supervisor_status: newProps.data.supervisor_status,
      reading_finish: newProps.data.reading_finish,
      fuel_type_id: newProps.data.fuel_type_id,
      fuel_types_select: newProps.fuel_types_select,
      last_type: newProps.last_type,
      request_data: newProps.request_data,
      user: newProps.user,
    }, () => {
      this.validateFields();
    });
  }

  autoFillTime (name) {

    var now = moment(new Date());
    now = now.format("HH:mm");

    this.props.handleChangeRefuelData(name, now, this.state.refuel_index);
  }

  // Função para validar os campos necessários
  validateFields() {
    var type = this.state.fields_type;

    // Verifico se os campos necessários estão preenchidos
    var isValid = false;
    if (type == 0) {
      isValid = (
        this.state.date != null &&
        this.state.receit != null &&
        this.state.quantity != null
      );
    }
    if (type == 1) {
      isValid = (
        this.state.date != null &&
        this.state.fueling_started != null &&
        this.state.fueling_finished != null &&
        this.state.reading_finish != null &&
        this.state.reading_start != null &&
        this.state.quantity != null &&
        // this.state.truck_no != null &&
        this.state.receit != null
      );
    }

    // Atualize o estado isFormValid
    this.setState({ is_form_valid: isValid });
  }

  approval_signature() {
    var self = this;
    var signature = this.refs.approveSignature;
    if(signature.isEmpty()) {
      window.alert(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.AlertaAssinaturaVazia);
      return false;
    }
    if(this.state.name === '' || this.state.name === null) {
      window.alert(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.placeholder.Nome);
      return false;
    }
    self.props.handleAlert('', '', 'open');
    var datasave = {
      image: signature.toDataURL(),
      flight_report_refuel_approval_id: this.state.flight_report_refuel_approval_id,
      name: this.state.name,
    };
    var header = self.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voo/abastecimento/aprovacao/login/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({
          modal_approval: false,
          name: '',
        });
        if (responseJson.status === 'success') {
          self.props.updateData(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  clearSignature () {
    var reproveSignature = this.refs.reproveSignature;
    if(typeof reproveSignature !== 'undefined') {
      reproveSignature.clear();
    }
    var approveSignature = this.refs.approveSignature;
    if(typeof approveSignature !== 'undefined') {
      approveSignature.clear();
    }
  }

  openLoginModal (flight_report_refuel_approval_id, type) {
    var name = null;
    if (type == 'supervisor') {
      name = this.state.supervisor_name;
    }
    if (type == 'customer') {
      name = this.state.user.name;
    }
    this.setState({
      flight_report_refuel_approval_id: flight_report_refuel_approval_id,
      modal_approval: true,
    });
  }

  // Fetch salvando a edição
  saveRefuel () {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      // Campos oriundos da solicitação
      aircraft_id: this.state.request_data.aircraft_id,
      flight_report_id: this.state.request_data.flight_report_id,
      flight_report_leg_id: this.state.request_data.flight_report_leg_id,
      base_id: this.state.request_data.base_id,
      maintenance_association: this.state.maintenance_association,
      extra_flight: this.state.extra_flight,
      internal_storage_tank: this.state.internal_storage_tank,
      fuel_supplier_id: this.state.request_data.fuel_supplier_id,
      refuel_reason_id: this.state.request_data.refuel_reason_id,
      location_id: this.state.request_data.location_id,
      requested: this.state.request_data.requested,
      company_id: this.state.request_data.company_id,
      address: this.state.request_data.address,
      staff_id: this.state.request_data.staff_id,
      next_location_id: this.state.request_data.next_location_id,
      water_check_before: this.state.request_data.water_check_before,
      water_check_during: this.state.request_data.water_check_during,
      water_check_after: this.state.request_data.water_check_after,
      helitank_id: this.state.request_data.helitank_id,
      
      // Campos originais do refuel
      id: this.state.id,
      date: this.state.date,
      comments: this.state.comments,
      flight_report_refuel_request_id: this.state.request_data.id,
      quantity: this.state.quantity,
      truck_no: this.state.truck_no,
      receit: this.state.receit,
      fueling_started: this.state.fueling_started,
      fueling_finished: this.state.fueling_finished,
      reading_finish: this.state.reading_finish,
      reading_start: this.state.reading_start,
      
      // Campos automáticos
      last_type: this.state.last_type, //Necessário para gravar o helitank_id
      fuel_type_id: this.state.fuel_type_id,
      your_sale_no: this.state.your_sale_no,
      previous_sale_no: this.state.previous_sale_no,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var url = config.get('api') + '/relatorio/voo/abastecimento/editar';
    var http_method = 'PUT';
    //Verifico se o id está indefinido ou nulo
    if (typeof this.state.id === 'undefined' || this.state.id === null) {
      url = config.get('api') + '/relatorio/voo/abastecimento';
      http_method = 'POST';
    }
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: http_method, mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); self.props.handleAlert(error.message, error.status, 'open');}).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.updateData(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  fields () {
      var type = this.state.fields_type;
      var fields = [];

      fields.push(
        <td hidden={true} className="text-center" style={{minWidth: '60px'}}>
          <div className="form-group">
            {(parseInt(this.state.refuel_index))}
          </div>
        </td>
      );
      fields.push(
        <td className="text-center" style={{minWidth: '150px'}}>
          <div className="form-group">
          <InputMask value={this.state.date} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="dd/mm/yyyy" required/>
          </div>
        </td>
      );

      if (type == 0) {
          fields.push(
              <td className="text-center" style={{minWidth: '150px'}}>
                  <div className="form-group">
                      <input type="text" name="receit" className="form-control" placeholder="" value={this.state.receit} onChange={this.handleChange.bind(this, 'receit')} required />
                  </div>
              </td>
          );
          fields.push(
              <td className="text-center" style={{minWidth: '150px'}}>
                  <div className="form-group">
                      <InputMask value={this.state.quantity} maskChar={null} name="quantity" mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'quantity')} placeholder="" required/>
                  </div>
              </td>
          );
      }

      if (type == 1) {
          fields.push(
            <td className="text-center" style={{minWidth: '150px'}}>
                <div className="form-group">
                    <InputMask value={this.state.reading_start} maskChar={null} name="reading_start" className="form-control" onChange={this.handleChangeGallonsReading.bind(this, 'reading_start')} placeholder="9999" required/>
                </div>
            </td>
          );
          fields.push(
              <td className="text-center" style={{minWidth: '250px'}}>
                  <div className="row form-group">
                      <div className="col-md-8">
                          <InputMask value={this.state.fueling_started} maskChar={null} name="fueling_started" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'fueling_started')} placeholder="hh:mm" required />
                      </div>
                      <div className="col-md-4">
                          <button type="button" className="btn btn-primary form-control" onClick={() => {this.autoFillTime('fueling_started')}}><i className="fa fa-angle-double-left"></i> <i className="fa fa-fw fa-clock-o"></i></button>
                      </div>
                  </div>
              </td>
          );
          fields.push(
              <td className="text-center" style={{minWidth: '250px'}}>
                  <div className="row form-group">
                      <div className="col-md-8">
                          <InputMask value={this.state.fueling_finished} maskChar={null} name="fueling_finished" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'fueling_finished')} placeholder="hh:mm" required />
                      </div>
                      <div className="col-md-4">
                          <button type="button" className="btn btn-primary form-control" onClick={() => {this.autoFillTime('fueling_finished')}}><i className="fa fa-angle-double-left"></i> <i className="fa fa-fw fa-clock-o"></i></button>
                      </div>
                  </div>
              </td>
          );
          fields.push(
              <td className="text-center" style={{minWidth: '150px'}}>
                  <div className="form-group">
                      <InputMask value={this.state.reading_finish} maskChar={null} name="reading_finish" className="form-control" onChange={this.handleChangeGallonsReading.bind(this, 'reading_finish')} placeholder="9999" required/>
                  </div>
              </td>
          );
          fields.push(
              <td className="text-center" style={{minWidth: '150px'}}>
                  <div className="form-group">
                      <InputMask value={this.state.quantity} maskChar={null} name="quantity" className="form-control" onChange={this.handleChange.bind(this, 'quantity')} placeholder="9999" required/>
                  </div>
              </td>
          );
          fields.push(
            <td className="text-center" style={{minWidth: '150px'}}>
                <div className="form-group">
                  <input type="text" name="receit" className="form-control" placeholder="999999" value={this.state.receit} onChange={this.handleChange.bind(this, 'receit')} required {...(this.state.auto_receit && {disabled: true})} />
                </div>
            </td>
          );
          // fields.push(
          //     <td className="text-center" style={{minWidth: '150px'}}>
          //         <div className="form-group">
          //           <input type="text" name="truck_no" className="form-control" placeholder="999" value={this.state.truck_no} onChange={this.handleChange.bind(this, 'truck_no')} required />
          //         </div>
          //     </td>
          // );
          // fields.push(
          //     <td className="text-center" style={{minWidth: '150px'}}>
          //         <div className="form-group">
          //             <Select
          //               className="form-field-name"
          //               name="fuel_type_id"
          //               value={this.state.fuel_type_id}
          //               searchable={true}
          //               placeholder={'Selecione'}
          //               onChange={this.handleSelectChange.bind(this, 'fuel_type_id')}
          //               options={this.state.fuel_types_select}
          //               required
          //               disabled={this.state.internal_storage_tank == 0 ? true : false}
          //             />
          //         </div>
          //     </td>
          // );
      }
      
      //Inclusao do novo campo commentarios;
      fields.push(
        <td className="text-center" style={{minWidth: '150px'}}>
          <div className="form-group">
            <input type="text" name="comments" className="form-control" value={this.state.comments} onChange={this.handleChange.bind(this, 'comments')} />
          </div>
        </td>
      );

      fields.push(
        <td className="text-center" style={{minWidth: '350px'}}>
            <div className="form-group button-group">
              <button type="button" className="btn btn-primary button-inline" onClick={() => this.saveRefuel()} disabled={!this.state.is_form_valid}><i className="fa fa-fw fa-save"></i></button>
              {typeof this.state.id !== 'undefined' && this.state.id !== null && this.state.customer_status == 'pending' &&
                <button type="button" onClick={() => {this.openLoginModal(this.state.customer_id, 'customer')}} className="btn btn-success btn-sm button-inline"><i className="fa fa-pencil-square-o"></i> Omni</button>
              }
              {typeof this.state.id !== 'undefined' && this.state.id !== null && this.state.supervisor_status == 'pending' &&
                <button type="button" onClick={() => {this.openLoginModal(this.state.supervisor_id, 'supervisor')}} className="btn btn-info btn-sm button-inline"><i className="fa fa-pencil-square-o"></i> Caribbean</button>
              }
              <button type="button" className="btn btn-danger button-inline" onClick={() => this.props.deleteRefuel(this.state.id, this.state.refuel_index)}><i className="fa fa-fw fa-close"></i></button>
            </div>
        </td>
      );
        
      return fields;
  }

  render() {
    var self = this;
    return (
      
        <tr>
          {this.fields()}
          <div>
          <RequestApi ref={'request_api'} />
          </div>

          {/* Modal de aprovação */}
          <Modal show={this.state.modal_approval} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
            <Modal.Header>
              <h4 className="pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.Titulo}</h4>
              <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal_approval: false})}>
              <i className="fa fa-fw fa-close"></i></button>
              <div className="clearfix"></div>
            </Modal.Header>
            <Modal.Body>
              <h4 className="pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.TituloPorAssinatura}</h4>
              <button className="btn btn-warning btn-sm pull-right" onClick={() => self.clearSignature()}><i className="fa fa-eraser"></i></button>
              <div className="clearfix"></div>
              <hr />
              <div className="row">
                <div className="col-md-4 col-md-offset-4 form-group text-center">
                  <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.Nome}:</label>
                  <input type="text" name="name" className="form-control" placeholder={this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.placeholder.Nome} value={this.state.name} onChange={this.handleChangeName.bind(this, 'name')} required/>
                </div>
              </div>
              <hr />
              <div className="text-center">
                <SignaturePad ref="approveSignature" />
              </div>
              <hr />
              <button className="btn btn-success btn-block" type="button" onClick={() => this.approval_signature()}><i className="fa fa-fw fa-sign-in"></i> {this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.BotaoAprovar}</button>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal_approval: false})}>
              <i className="fa fa-fw fa-close"></i></button>
            </Modal.Footer>
          </Modal>

        </tr>

    );
  }
}

export default FlightReportRefuelMultipleFieldsTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReportRefuels/Elements/FlightReportRefuelMultipleFieldsTab.js